import * as React from 'react'
import { DefaultCheckbox, DynamicPropertyInput, SelectInput } from '../../components/atoms/Inputs'
import { TranslatedTerms } from '../../globals/TranslatedTerms'
import { FieldTypes } from '../../shared/KYCPolicy'
import { lang } from '../../globals/Translations'
import Language, { AvailabeLanguages, LanguageId } from '../../shared/Language'
import { DefaultId, FBPersons, FBReferrerOptions } from '../../shared/Globals'
import { AuthenticationBody } from '../../components/templates/AuthenticationWrapper'
import colors from '../../globals/colors';
import { signOut } from '../../globals/AuthHooks'
import { checkForAlias, createInvestor } from '../../globals/ApiHooks';
import { Auth } from 'aws-amplify'
import { delay } from '../../globals/UIHooks'


const PersonReference = "reference-fb-person"

enum OnboardingStep {
    FIRST = "FIRST",
    SECOND = "SECOND"
}

export const OnboardingPage: React.FC = () => {
    const [fname, setFname] = React.useState<string>()
    const [lname, setLname] = React.useState<string>()
    const [country, setCountry] = React.useState<string>()
    const [phone, setPhone] = React.useState<string | undefined>("+45")
    const [language, setLanguage] = React.useState<LanguageId>(DefaultId)

    const [reference, setReference] = React.useState<string>()
    const [nameOfRep, setNameOfRep] = React.useState<string>()

    const [acceptNewsletter, setAcceptNewsletter] = React.useState<boolean>(false)
    const [loading, setLoading] = React.useState<boolean>(false)
    const [error, setError] = React.useState<string>("")

    const [setp, setStep] = React.useState<OnboardingStep>(OnboardingStep.FIRST)

    const setValue = (setter: (value?: string) => void) => (input?: string | number) => setter(input?.toString())

    const completed = fname && fname.length > 1 && lname && lname.length > 1 && country && language && phone

    const nextStep = () => {
        if (!(fname && fname.length > 1 && lname && lname.length > 1 && phone && country)) return setError(lang(TranslatedTerms.ONBOARDING_ERROR_FIELDS_MESSAGE))
        setError("")
        setStep(OnboardingStep.SECOND)
    }
    const checkIfUserEmailExists = async () => {
        setLoading(true)
        const user = await Auth.currentAuthenticatedUser()
        const username = user.username
        const result = await checkForAlias({ username })
        if (result && result.successfullySetupAlias === true) window.location.reload()
        setLoading(false)
    }

    React.useEffect(() => { checkIfUserEmailExists() }, [])

    const prevStep = () => setStep(OnboardingStep.FIRST)

    const submit = async () => {
        if (!language || !country) return setError(lang(TranslatedTerms.ONBOARDING_ERROR_CONTRY_MESSAGE))
        if (!completed) return setError(lang(TranslatedTerms.ONBOARDING_ERROR_FIELDS_MESSAGE))
        setLoading(true)
        const user = await Auth.currentAuthenticatedUser()
        const email = user.attributes.email
        const investorSource = reference === PersonReference && nameOfRep ? nameOfRep : reference
        await createInvestor({ fname, lname, email, country, language, phone, investorSource: investorSource, acceptNewsletter })
        //@ts-ignore
        window.dataLayer = window.dataLayer || []
        //@ts-ignore
        window.dataLayer.push({
            'event': 'user_signup'
        })
        delay(500)
        window.location.reload()
        setLoading(false)
    }

    return (
        <AuthenticationBody loading={loading}>
            <>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 10 }}>
                    <img
                        width="250px"
                        src="https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/59c23268-89c9-4132-9a6c-c97a7aa61eff.png"
                        alt="Fundbricks logo" />
                </div>
                <h6 style={{ textAlign: 'center', color: colors.grayText }}>..{lang(TranslatedTerms.AND_A_LAST_THING)}</h6>
                {
                    setp === OnboardingStep.FIRST && (
                        <>
                            <p className="small">{lang(TranslatedTerms.NAME_CONTRY_LANGUAGE_DESCRIPTION)}.</p>
                            <DynamicPropertyInput fieldName={TranslatedTerms.FIRST_NAME} type={FieldTypes.TextField} value={fname} setValue={setValue(setFname)} />
                            <DynamicPropertyInput fieldName={TranslatedTerms.LAST_NAME} type={FieldTypes.TextField} value={lname} setValue={setValue(setLname)} />
                            <DynamicPropertyInput fieldName={TranslatedTerms.PHONE} type={FieldTypes.PhoneField} value={phone} setValue={setValue(setPhone)} />
                            <DynamicPropertyInput fieldName={TranslatedTerms.COUNTRY} type={FieldTypes.CountrySelect} value={country} setValue={setValue(setCountry)} />
                            <button onClick={nextStep} style={{ marginTop: 20, width: '100%' }}>{lang(TranslatedTerms.NEXT)}</button>
                            <p style={{ color: colors.danger }}>{error}</p>
                            <a onClick={signOut} style={{ color: colors.grayText }}>{lang(TranslatedTerms.LOG_OUT)}</a>
                        </>
                    )
                }
                {
                    setp === OnboardingStep.SECOND && (
                        <>
                            <SelectInput options={FBReferrerOptions} fieldName={TranslatedTerms.WHERE_HAVE_YOU_HEARD_ABOUT_FUNDBRICKS}
                                itemRender={(e: string) => lang(e)} getValue={(e: string) => e}
                                onSelect={(id) => setReference(id)} />
                            {reference === PersonReference && (
                                <SelectInput options={FBPersons} fieldName={TranslatedTerms.NAME_OF_FUNDBRICKS_REP}
                                    itemRender={(e: string) => e} getValue={(e: string) => e}
                                    onSelect={setNameOfRep} />
                            )}
                            <SelectInput options={AvailabeLanguages} fieldName={TranslatedTerms.LANGUAGE}
                                itemRender={(e: Language) => e.localDisplayName} getValue={(e: Language) => e.languageId}
                                onSelect={(id: LanguageId) => setLanguage(id)} />
                            <div style={{ height: 10 }}></div>
                            <DefaultCheckbox handleClick={() => setAcceptNewsletter(!acceptNewsletter)}
                                description={lang(TranslatedTerms.ACCEPT_NEWSLETTER_DESCRIPTION)} />
                            <button onClick={submit} style={{ marginTop: 20, width: '100%' }}>{lang(TranslatedTerms.COMPLETE_PROFILE)}</button>
                            <p style={{ color: colors.danger }}>{error}</p>
                            <a onClick={prevStep} style={{ color: colors.grayText }}>{lang(TranslatedTerms.GO_BACK)}</a>
                        </>
                    )
                }
            </>
        </AuthenticationBody>
    )
}

